export enum ResolveFlaggedScanScreen {
    DOCTOR_CHOICE = 'DOCTOR_CHOICE',
    DOCTOR_NOTES = 'DOCTOR_NOTES',
    THANK_YOU = 'THANK_YOU',
    CONFIRM_STOP = 'CONFIRM_STOP',
}
